import React from 'react';

const TYPE_COLORS = {
  'Election Dispute': { color: '#64d2ff', bg: 'rgba(100,210,255,0.08)', icon: '🗳' },
  'Financial Records Access': { color: '#ffd60a', bg: 'rgba(255,214,10,0.08)', icon: '📄' },
  'Special Assessment': { color: '#ff9f0a', bg: 'rgba(255,159,10,0.08)', icon: '💸' },
  'Recall Dispute': { color: '#bf5af2', bg: 'rgba(191,90,242,0.08)', icon: '⚡' },
  'Structural Safety': { color: '#ff453a', bg: 'rgba(255,69,58,0.08)', icon: '🏗' },
};

function getType(type) {
  return TYPE_COLORS[type] || { color: 'var(--text-secondary)', bg: 'var(--bg-elevated)', icon: '•' };
}

export default function ComplaintTimeline({ complaints }) {
  const sorted = [...complaints].sort((a, b) => b.year - a.year);

  return (
    <div style={{
      background: 'var(--bg-card)',
      border: '1px solid var(--border)',
      borderRadius: 'var(--radius-lg)',
      overflow: 'hidden',
    }}>
      {sorted.map((c, i) => {
        const { color, bg, icon } = getType(c.type);
        const isOpen = c.status === 'Open';
        return (
          <div key={i} style={{
            display: 'flex', gap: 16, padding: '16px 20px',
            borderBottom: i < sorted.length - 1 ? '1px solid var(--border-subtle)' : 'none',
            alignItems: 'flex-start',
          }}>
            {/* Year + icon */}
            <div style={{ flexShrink: 0, width: 48, textAlign: 'center' }}>
              <div style={{ fontSize: 11, fontWeight: 700, color: 'var(--text-tertiary)', marginBottom: 4 }}>{c.year}</div>
              <div style={{
                width: 32, height: 32, borderRadius: 8,
                background: bg, display: 'flex', alignItems: 'center', justifyContent: 'center',
                fontSize: 14, margin: '0 auto',
              }}>
                {icon}
              </div>
            </div>

            {/* Content */}
            <div style={{ flex: 1, minWidth: 0 }}>
              <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', gap: 8, marginBottom: 4, flexWrap: 'wrap' }}>
                <span style={{ fontSize: 13, fontWeight: 600, color }}>{c.type}</span>
                <span style={{
                  fontSize: 10, fontWeight: 600, letterSpacing: 0.5, textTransform: 'uppercase',
                  padding: '2px 8px', borderRadius: 100,
                  background: isOpen ? 'var(--risk-high-bg)' : 'rgba(255,255,255,0.05)',
                  border: `1px solid ${isOpen ? 'var(--risk-high-border)' : 'var(--border)'}`,
                  color: isOpen ? 'var(--risk-high)' : 'var(--text-tertiary)',
                  flexShrink: 0,
                }}>
                  {c.status}
                </span>
              </div>
              <p style={{ fontSize: 13, color: 'var(--text-secondary)', lineHeight: 1.5 }}>
                {c.description}
              </p>
            </div>
          </div>
        );
      })}
    </div>
  );
}
